import { render, staticRenderFns } from "./SetPayPassword.vue?vue&type=template&id=fb80c1ce&scoped=true&"
import script from "./SetPayPassword.vue?vue&type=script&lang=js&"
export * from "./SetPayPassword.vue?vue&type=script&lang=js&"
import style0 from "./SetPayPassword.vue?vue&type=style&index=0&id=fb80c1ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb80c1ce",
  null
  
)

export default component.exports